
import { NavigationKey } from '../../../types';

export const navigation: Record<NavigationKey, string> = {
  welcome: 'Bem-vindo',
  dashboard: 'Dashboard',
  myVideos: 'Meus Vídeos',
  analytics: 'Análises',
  settings: 'Configurações',
  profile: 'Perfil',
  logout: 'Sair',
  feed: 'Feed',
  latestVideos: 'Vídeos Recentes',
  finance: 'Finanças',
  support: 'Suporte',
  tracking: 'Rastreamento',
  integrations: 'Integrações',
  security: 'Segurança',
  partners: 'Parceiros',
  help: 'Ajuda',
  início: 'Início',
  novoVídeo: 'Novo Vídeo',
  personalização: 'Personalização',
  funnelVideo: 'Funil de Vídeo',
  vsleads: 'VSLeads',
  métricas: 'Métricas',
  testeAB: 'Teste A/B',
  hookTrack: 'Teste de hook',
  rastreamento: 'Rastreamento',
  integrações: 'Integrações',
  segurança: 'Segurança',
  proteçãoDomínios: 'Proteção Domínios',
  cloakerVSL: 'Cloaker de VSL',
  parceiros: 'Parceiros',
  membros: 'Membros',
  botaoAcao: 'Botão de Ação',
  ajuda: 'Ajuda',
  masterClass: 'Master Class',
  compartilhar: 'Compartilhar',
  capturaLeads: 'Captura de Leads',
  dominios: 'Domínios',
  chat: 'Chat',
  centralAjuda: 'Central de Ajuda',
  cloaker: 'Cloaker',
  personalizar: 'Personalizar',
};
